__turbopack_context__.v({
  "className": "manrope_8cd5c4d3-module__456lhW__className",
  "variable": "manrope_8cd5c4d3-module__456lhW__variable",
});
